// Main marketplace route. The app-level shell (grid, 100dvh, theme,
// fontSize, assistant margin-right transition) lives on the root
// component in `app.js`. This page renders a `MarketplaceIsland` —
// the same self-contained unit that canvas + landing embed, so
// standalone stays in sync with embeddable surfaces without
// duplicating layout or state wiring.

export const main = {
  extends: 'Page',
  display: 'grid',
  gridTemplateRows: '1fr',
  width: '100%',
  height: '100%',
  overflow: 'hidden',

  MarketplaceIsland: {}
}
